import './FrontC.sass';
import './FrontE.sass';
import './FrontF.sass';
import { useArticles } from '../api';

import Hero from '../components/Hero';
import Breadcrumbs from '../components/Breadcrumbs';
import Meta from '../components/Meta';

// import titleBar from '../assets/common/title-bar.svg';
import { Link } from 'react-router-dom';

const Articles = (props) => {
	const { guid, route, url } = props;
	const { articles } = useArticles(guid, route, '', '', '');

	return (
		<div className='tab-content'>
			{articles.map((article) => {
				const { title, summary } = article;

				return (
					<div className='article' key={article.guid}>
						<div className='left'>
							<div className='img-ratio-wrap' style={{ backgroundImage: `url(${article.thumb})` }}></div>
						</div>

						<div className='right'>
							<div className='content-wrap'>
								<div className='top'>
									<div className='title'>{title}</div>
									<div className='summary'>{summary}</div>
								</div>

								<div className='bot'>
									<Link to={`${url || route}/${article.guid}`}>
										<div className='text'>繼續閱讀</div>
										<div className='icon'>
											<img src='/assets/arrow.svg' alt='' />
										</div>
									</Link>
								</div>
							</div>
						</div>
					</div>
				);
			})}
		</div>
	);
};

const FrontF = (props) => {
	const { routeData } = props;
	const { breadcrumbs } = useArticles(routeData.guid, routeData.route, '', '', '');

	return (
		<div className='FrontE FrontC FrontF min-page-height'>
			<Meta data={routeData} />
			<Hero data={breadcrumbs} />
			<Breadcrumbs data={breadcrumbs} />

			<div className='common-pad-wrap'>
				<div className='page-content'>
					{routeData.categoryChild?.map((item) => {
						const { name, guid, description, categoryChild, route, url } = item;
						return (
							<div className='section-group' key={guid}>
								<div className='title-with-bar'>
									{/* <div className='bar'>
										<img src={titleBar} alt='' />
									</div> */}
									{name}
								</div>

								{description && <div className='description'>{description}</div>}

								{categoryChild.map((subgroup) => {
									return (
										<div className='subgroup' key={subgroup.guid}>
											<div className='subgroup-heading'>{subgroup.name}</div>

											<Articles guid={subgroup.guid} route={subgroup.route} url={subgroup.url} />
										</div>
									);
								})}

								<Articles guid={guid} route={route} url={url} />
							</div>
						);
					})}
				</div>
			</div>
		</div>
	);
};

export default FrontF;
